<template>
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
            v-for="item in items"
            :key="item.path"
            :to="{ path: item.path }"
            >{{ item.meta.label }}
        </el-breadcrumb-item>
    </el-breadcrumb>
</template>

<script>
export default {
    computed: {
        items() {
            return this.$route.matched.filter((item) => {
                return !!item.meta.label;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.el-breadcrumb {
    margin-left: 30px;
    padding: 0 20px;
    margin-bottom: 20px;
}
</style>
